module.exports = __webpack_public_path__ + "media/01_soredemo_kamisamaha_irundayone.450bba51.mp3";